const PENDING_RETURN_TO_KEY = "lumen:pending-return-to";

/** Only allow same-origin application paths to be used as return targets. */
export function safeReturnTo(value: string | null | undefined, fallback = "/") {
  if (!value || !value.startsWith("/") || value.startsWith("//"))
    return fallback;
  if (value.includes("\\") || value.includes("\u0000")) return fallback;
  return value;
}

export function navigationTarget(
  location: Pick<Location, "pathname" | "search" | "hash">,
) {
  return safeReturnTo(`${location.pathname}${location.search}${location.hash}`);
}

export function isSharedChatPath(pathname: string) {
  return /^\/share\/[^/]+\/?$/.test(pathname);
}

export function rememberPendingReturnTo(value: string) {
  const target = safeReturnTo(value);
  try {
    window.localStorage.setItem(PENDING_RETURN_TO_KEY, target);
  } catch {
    // Storage may be unavailable; the current URL still remains safe.
  }
}

export function consumePendingReturnTo() {
  try {
    const target = safeReturnTo(
      window.localStorage.getItem(PENDING_RETURN_TO_KEY),
    );
    window.localStorage.removeItem(PENDING_RETURN_TO_KEY);
    return target;
  } catch {
    return "/";
  }
}

export const sessionExpiredEvent = "lumen:session-expired";
